const loop = (node, offsets, index = 0) => {

  if (index < offsets.length) {

    return loop(
      node.childNodes[offsets[index]],
      offsets,
      index + 1
    )

  } else {

    return node

  }

}

module.exports = loop



// WEBPACK FOOTER //
// ../node_modules/vqua/lib/dom/findDomNode.js